import clsx from 'clsx'

import { Text } from '@wartek-id/text'

import { formatDateOnly } from '@/utils/date'

export const LastUpdatedAt = ({
  value,
  className = '',
  testId = 'txt-last-updated-at',
}) => {
  return (
    <Text className={clsx('mt-4', className)} data-testid={testId}>
      Pembaruan Terakhir: {formatDateOnly(value)}
    </Text>
  )
}
